<form [formGroup]="form" (ngSubmit)="onSubmit()" class="mt-4 mb-4 w-100 text-light p-5 border">

    <div class="d-flex flex-column flex-sm-row justify-content-between">
        <div class="mb-3 col-12 col-sm-5 p-0">
            <input type="text" class="form-control" formControlName="name" placeholder="Nombre y apellidos *"
                [class.is-invalid]="form.controls.name.touched && form.controls.name.invalid">
        </div>

        <div class="mb-3 col-12 col-sm-6 p-0">
            <input type="email" class="form-control" formControlName="email" placeholder="Email *"
                [class.is-invalid]="form.controls.email.touched && form.controls.email.invalid">
        </div>
    </div>

    <div class="mb-3 col-12 p-0 text-left">
        <label class="form-label">¿Prefieres llamada o WhatsApp? (teléfono) *</label>
        <div class="flex-row">
            <select class="form-select col-3" formControlName="prefix">
                <option *ngFor="let p of prefixes()" [value]="p.prefix">
                    {{ p.country }} ({{ p.prefix }})
                </option>
            </select>
            <input type="text" class="form-control ms-3 ml-3" formControlName="phone"
                [class.is-invalid]="form.controls.phone.touched && form.controls.phone.invalid">
        </div>
    </div>

    <div class="mb-3 text-left">
        <label class="form-label">¿Sector profesional al que perteneces? *</label>
        <select class="form-select" formControlName="sector">
            <option value="">Selecciona una opción</option>
            <option *ngFor="let s of sectors" [value]="s">{{ s }}</option>
        </select>

        <input *ngIf="form.value.sector === 'Otro'" type="text" class="form-control mt-2"
            placeholder="Especifica tu sector" formControlName="otherSector">

        <div class="text-danger" *ngIf="form.controls.sector.touched && form.controls.sector.invalid">
            El sector es obligatorio.
        </div>
    </div>

    <div class="mb-3 text-left">
        <label class="form-label">Motivo de contacto *</label>
        @for (motive of motives; track motive) {
        <div class="form-check mb-1">
            <input type="checkbox" class="form-check-input" [value]="motive" (change)="toggleMotive($event, motive)"
                id="motive-{{ motive }}">
            <label class="form-check-label" for="motive-{{ motive }}">
                {{ motive }}
            </label>
        </div>
        }

        <input *ngIf="motivesSelected().includes('Otro')" type="text" class="form-control mt-2"
            placeholder="Especifica tu motivo" formControlName="otherMotive">

        <div class="text-danger" *ngIf="motivesTouched() && motivesSelected().length === 0">
            Debes elegir al menos un motivo.
        </div>
    </div>

    <div class="form-check mb-3 justify-content-center">
        <label class="form-check-label">
            <input type="checkbox" class="form-check-input" formControlName="warning">
            Acepto los <a href="/aviso-legal/privacidad" target="_blank">términos y condiciones</a> *
        </label>
        <div class="text-danger" *ngIf="form.controls.warning.touched && form.controls.warning.invalid">
            Debes aceptar los términos.
        </div>
    </div>

    <p *ngIf="success()" class="success-text">
        ¡Formulario enviado con éxito!
    </p>

    <p *ngIf="error()" class="error-text">
        Ha ocurrido un error al enviar el formulario. Inténtalo de nuevo.
    </p>

    <button class="btn btn-light" type="submit" [disabled]="loading() || !formReady()">
        {{ loading() ? "Enviando..." : "Enviar" }}
    </button>

</form>